<template>
  <modal-component
    @close="onClose"
    @aceptar="onClose"
    buttonLabel="Cerrar"
    :bodyScroll="isMobile"
    :label="label"
    :show="true"
  >
    <div class="container">
      <p class="titulo">Clave y Usuario Digital</p>
      <p class="subtitulo">
        Ingresá a nuestra página web o a BBVA Móvil y seguí éstos pasos:
      </p>
      <div class="bullets-container">
        <span class="bullet">
          <img
            class="bullet-img"
            src="@/assets/img/1x/li-azul.png"
            alt="Linea azul"
          />
          <p class="bullet-text">Hacé click en el botón "Banca Online".</p>
        </span>
        <span class="bullet">
          <img
            class="bullet-img"
            src="@/assets/img/1x/li-azul.png"
            alt="Linea azul"
          />
          <p class="bullet-text">Seleccioná "Registrarme".</p>
        </span>
        <span class="bullet">
          <img
            class="bullet-img"
            src="@/assets/img/1x/li-azul.png"
            alt="Linea azul"
          />
          <p class="bullet-text">
            Contestá las preguntas referidas a tus productos o sobre la
            información que concediste al Banco.
          </p>
        </span>
        <span class="bullet">
          <img
            class="bullet-img"
            src="@/assets/img/1x/li-azul.png"
            alt="Linea azul"
          />
          <p class="bullet-text">
            Al finalizar te sugerimos que generes las preguntas de recuperación.
            El “Usuario” debe tener entre 6 y 20 letras. La “Clave Digital” 8
            dígitos y tener por lo menos 1 letra y 1 número.
          </p>
        </span>
        <span>
          <p class="o-podes">
            O podés
            <a
              href="https://www.youtube.com/watch?v=gUX5VA6XWWk"
              target="_blank"
              rel="noopener"
              >ver nuestro video explicativo</a
            >.
          </p>
        </span>
      </div>
    </div>
  </modal-component>
</template>
<script>
import ModalComponent from "@/components/core/ModalComponent";

export default {
  name: "ModalClaveUsuario",
  components: {
    ModalComponent
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    resizeHandler() {
      this.windowWidth = window.innerWidth;
    }
  },
  data() {
    return { windowWidth: window.innerWidth };
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  computed: {
    isMobile() {
      return this.windowWidth < 600;
    },
    label() {
      return this.windowWidth < 600 ? "Clave y Usuario Digital" : "";
    }
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
  color: #1973b8;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.titulo {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #121212;
}

.subtitulo {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #121212;
  margin-top: -10px;
  margin-bottom: 35px;
}

.container {
  width: 100%;
  text-align: center;
}

.bullets-container {
  width: 580px;
  text-align: left;
}

.bullet {
  display: block;
  margin-bottom: 16px;
}

.bullet-img {
  display: inline-block;
  margin-right: 10px;
  margin-left: 30px;
  vertical-align: top;
  width: 20px;
}

.bullet-text {
  display: inline-block;
  vertical-align: top;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #121212;
  margin-top: 0px;
  margin-bottom: 0px;
  width: 90%;
}

.o-podes {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #121212;
  margin-top: 24px;
  margin-bottom: 40px;
  margin-left: 40px;
}

@media screen and (max-width: 600px) {
  .bullets-container {
    width: 95%;
  }
  .bullet-img {
    margin-left: 5px;
  }
  .titulo {
    display: none;
  }
  .subtitulo {
    margin-top: 0px;
  }
}
</style>
